import React, { useEffect, useState } from "react";
import { Newspaper, Loader2 } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import { BlogCard } from "../components/BlogCard";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";

const BlogPage = () => {
  const [posts, setPosts] = useState(null);

  useSeo({
    title: "Blog – Συμβουλές Τεχνολογίας & Επισκευών | Repairzone Π.Κ Λαμία",
    description: "Πρακτικοί οδηγοί και νέα τεχνολογίας για κινητά, laptop, υπολογιστές και κονσόλες από τους τεχνικούς της Repairzone Π.Κ στη Λαμία και τη Φθιώτιδα.",
    path: "/blog",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-28 pb-24 max-w-7xl mx-auto px-5 lg:px-8" data-testid="blog-page">
        <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80 inline-flex items-center gap-2">
          <Newspaper className="w-4 h-4" /> Blog
        </div>
        <h1 className="mt-2 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight">
          Συμβουλές & νέα <span className="text-emerald-400">τεχνολογίας</span>
        </h1>
        <p className="mt-4 text-emerald-50/70 max-w-2xl">
          Πρακτικοί οδηγοί για κινητά, laptop, υπολογιστές και κονσόλες από τους τεχνικούς της Repairzone στη Λαμία και τη Φθιώτιδα.
        </p>

        {posts === null && (
          <div className="mt-16 flex justify-center text-emerald-300">
            <Loader2 className="w-6 h-6 animate-spin" />
          </div>
        )}
        {posts && posts.length === 0 && (
          <div className="mt-16 pcb-card p-10 text-center text-emerald-100/70" data-testid="blog-empty">
            Τα πρώτα άρθρα έρχονται σύντομα.
          </div>
        )}
        {posts && posts.length > 0 && (
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {posts.map((p, i) => (
              <BlogCard key={p.id} post={p} featured={i === 0} />
            ))}
          </div>
        )}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default BlogPage;
